/*
* Adds a CookiePolicyWidget class to the Confused namespace. 
* Implemented as IIFE so we can pass in references to the global jQuery, window and document objects.
* Note: Depends on _partials/Common/v1.0/CookieManager.js being setup at Confused.CookieManager and _core/mi/v1.1/miListener.js (or above) being supported server-side.
* Adds/ removes "cookie-popup--hidden" to #cookie-popup depending on the presence of a CookieConsent cookie, logging the interaction as an MI event and in a cookie
*/

; (function ($, w, d) {

    "use strict";

    w.Confused = w.Confused || {};
    w.Confused.CookieManager = w.Confused.CookieManager || {};

    w.Confused.CookiePolicyWidget = (function (cookieManager) {

        var cookieName = "CookieConsent";
        var cookiePolicy = "#CookiePolicy";
        var slideInClass = "cookie-wrapper--slide-in";
        var parent = location.hostname;
        var domainRegex = /^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])(\.([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]{0,61}[a-zA-Z0-9]))*$/i;
        var miListener = CONFUSEDCORE.MI.MiListener;

        if (domainRegex.test(parent)) {

            var parts = parent.split(".");
            parts.shift();
            parent = parts.join(".");
        }

        /* Show widget */
        function showPopup() {
            setTimeout(function () {
                $(cookiePolicy).addClass(slideInClass);
            }, 1000);
        }

        /* Hide widget */
        function hidePopup(cookieValue, eventName, timeout) {
            if (!cookieManager.hasItem(cookieName)) {
                miListener.postEvent(eventName);
                cookieManager.setItem(cookieName, cookieValue, 2147483647, "/", parent);

                if (cookieValue === "false") {
                    $("#CookieConsentMessage").hide();
                    $("#CookieConsentClose").hide();
                    $("#CookieDeclineMessage").show();
                }

                setTimeout(function() {
                        $(cookiePolicy).addClass(slideInClass);
                        $(cookiePolicy).removeClass(slideInClass);
                    },
                    timeout);
            }
        }

        function run() {

            if (!cookieManager.hasItem(cookieName)) {
                $(function () {
                    miListener.postEvent("CookiePopupShown");
                    showPopup();
                });
                $("body").on("click", function (e) {
                    if (e.target.id === "CookieConsentFalse" || e.target.id === "CookieConsentClose" || !$(cookiePolicy).hasClass(slideInClass)) {
                        return;
                    }
                    hidePopup("true", "CookiePopupDismissed:ConsentGranted", 0);
                });

                $("#CookieConsentClose").on("click", function () {
                    hidePopup("true", "CookiePopupClosed:ConsentGranted", 0);
                });
   
                $("#CookieConsentFalse").on("click", function () {
                    hidePopup("false", "CookiePopupClosed:ConsentDeclined", 4000);
                });
            }
            return;

        }
        return {
            run: run
        };
    })(new w.Confused.CookieManager());

    w.Confused.CookiePolicyWidget.run();

}(window.jQuery, window, document, window.Confused.CookieManager));